import "./related-articles-block.scss";